import vueMainInstance from "../../main";

export default class Booking {
  constructor() {
    this.id = null;
    this.type = "";
    this.name = "";
    this.ticket_number = "";
    this.reservation_number = "";
    this.client_name = "";
    this.client_surname = "";
    this.total_amount = 0;
    this.creation_date = "";
    this.is_cancelled = false;
    this.used_in_delegation = false;
    this.invoices = [];
  }

  load(userId, loadUrl = "booking/get-booking-detail?bookingId=") {
    vueMainInstance.axios.get(loadUrl + userId).then(resp => {
      this.id = resp.data.id;
      this.passengers = resp.data.passengers;
      this.type = resp.data.type;
      this.name = resp.data.name;
      this.ticket_number = resp.data.ticket_number;
      this.reservation_number = resp.data.reservation_number;
      this.client_name = resp.data.client_name;
      this.client_surname = resp.data.client_surname;
      this.total_amount = resp.data.total_amount;
      this.creation_date = resp.data.creation_date;
      this.is_cancelled = resp.data.is_cancelled;
      this.used_in_delegation = resp.data.already_used;
      this.invoices = resp.data.invoices;
    });
  }
}
